import React from "react";
import { useTranslation } from "react-i18next";

function Menu({ isOpen, onClose }) {
  const { t } = useTranslation();

  const navigation = [
    {
      id: 1,
      label: t("about"),
      elementId: "aboutContainer",
    },
    {
      id: 2,
      label: t("categories"),
      elementId: "categoriesContainer",
    },
    {
      id: 3,
      label: t("judgingProcess"),
      elementId: "judgingProcessContainer",
    },
    {
      id: 4,
      label: t("faq"),
      elementId: "faqContainer",
    },
    {
      id: 5,
      label: t("contact"),
      elementId: "contactContainer",
    },
  ];

  const onClickNavbarMenu = (elementId) => {
    const el = document.getElementById(elementId);
    const offset = elementId === "contactContainer" ? -80 : -120;
    const y = el.getBoundingClientRect().top + window.pageYOffset + offset;

    window.scrollTo({ top: y, behavior: "smooth" });

    onClose();
  };

  return (
    <div
      className={`sm:hidden fixed top-0 bottom-0 left-0 right-0 bg-white/50 backdrop-blur-lg ${
        isOpen ? "inline-block" : "hidden"
      } z-50`}
    >
      <div className="flex flex-col h-full gap-8 app-nav-container">
        <div className="font-medium text-right">
          <button
            className="text-sm transition-all active:border-b-2 active:border-black"
            onClick={onClose}
          >
            Close
          </button>
        </div>
        <div className={`flex flex-col justify-between flex-1`}>
          <ul className="flex flex-col gap-2 font-medium">
            {navigation &&
              navigation.map((nav, i) => {
                const navPath = nav && nav.href;
                const navLabel = nav && nav.label;
                return (
                  <li className="app-animation-translate-start" key={i}>
                    <a
                      href={navPath}
                      onClick={() => onClickNavbarMenu(nav?.elementId)}
                      className="cursor-pointer"
                    >
                      {navLabel}
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Menu;
